// helper functions for building and sending invite mails and other messages
import * as R from 'ramda'

// fallback name in case the logged in user is nameless (should not happen).
const FALLBACK_SENDER_NAME = 'EBBER Selection'

const makeContext = R.applySpec({
  name: R.prop('name'),
  questions: R.pipe(
    R.pathOr({}, ['gma', 'answers']),
    R.keys,
    R.length,
  ),
  minutes: R.pipe(
    R.pathOr(0, ['gma', 'secondsTotal']),
    R.divide(R.__, 60),
    Math.floor,
  ),
  url: R.prop('quiz_url'),
})

const senderName = R.pipe(
  R.props(['first_name', 'last_name']),
  R.filter(R.identity),
  R.ifElse(R.length, R.join(' '), R.always(FALLBACK_SENDER_NAME)),
)

export const renderMessage = ({
  template = {},
  candidate = {},
  sender = {},
  context = {},
}) => ({
  sender_name: template.sender_name || senderName(sender),
  receiver_name: candidate.name,
  subject: template.subject,
  body: R.pipe(
    makeContext,
    R.mergeLeft(context),
    renderBody(template.body || ''),
    R.trim,
  )(candidate),
  templateId: template.id,
})

export const renderBody = template => context => {
  // simple template rendering
  const replacer = (match, group) => R.prop(group, context) || match
  return R.replace(/\{\{ *([^} ]+) *\}\}/g, replacer, template)
}
